import { render, staticRenderFns } from "./PersonalCardTypeDelete.vue?vue&type=template&id=9aeded66&"
import script from "./PersonalCardTypeDelete.vue?vue&type=script&lang=js&"
export * from "./PersonalCardTypeDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports